import React from 'react';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import styled from 'styled-components';
import { isIpad, isMobileView } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { BROWN_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX } from 'src/styles/fonts/MCFontConstants';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';


const QuantityRPCheckboxes = ({
    item,
    index,
    lotItem,
    lotItemIdx,
    lotSerialValueEntered,
    showTopLabel,
    isChildItem,
}) => {
    const { t } = useTranslation();
    const adjQtyLabel = useAdjQtyLabel();
    const winWidth = window.innerWidth;
    return (
        <Wrapper>
            {/* Used Checkbox */}
            <Container
                padding={
                    showTopLabel
                        ? isMobileView()
                            ? '0px'
                            : isIpad()
                            ? '0px'
                            : '0 15px 0 0px'
                        : '10px 12px 0'
                }
                marginTop={isMobileView() ? '0px' : isIpad() ? '0px' : '-5px'}
                marginLeft={isMobileView() ? '0px' : '0'}
            >
                {showTopLabel && lotItemIdx === 0 && (
                    <CustomLabel
                        fSize={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '12px!important'
                                : '13px!important'
                        }
                        color={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '#140F4B'
                                : '#3c3c3c'
                        }
                        opacity={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '70%'
                                : '100%'
                        }
                        label={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? t('reportUsage.itemList.used')
                                : t('reportUsage.record.priceOverride.AccountOwnedList.index.used')
                        }
                        textAlign={'center'}
                        marginBottom={'15px'}
                    />
                )}
                <Checkbox 
                    checked={item?.usedQuantity || lotItem?.used || false}
                    onCheckboxSelectionChange={(e) =>
                        lotSerialValueEntered(
                            e,
                            item,
                            index,
                            lotItem,
                            lotItemIdx,
                            'usedChecked'
                        )
                    }
                    id="reportUsage-record-reportPayment-QuantityRPCheckboxes-used"
                    margin={'0px 15px 0 0'}
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        color: BROWN_FONT_COLOR,
                    }}
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                    ariaLabel={
                        isMobileView() || winWidth <= sizes.smalDevice
                            ? t('reportUsage.itemList.used')
                            : t('reportUsage.record.priceOverride.AccountOwnedList.index.used')
                    }
                />
            </Container>

            {/* Other Checkbox */}
            {!item?.isBundleItem && !isChildItem && (
                <Container
                    padding={
                        showTopLabel
                            ? isMobileView()
                                ? '0px'
                                : isIpad()
                                ? '0px'
                                : '0 15px 0 0px'
                            : '10px 12px 0'
                    }
                    marginTop={isMobileView() ? '0px' : isIpad() ? '0px' : '-5px'}
                    marginLeft={isMobileView() ? '10px' : '10px'}
                >
                    {showTopLabel && lotItemIdx === 0 && (
                        <CustomLabel
                            fSize={
                                isMobileView() || winWidth <= sizes.smalDevice
                                    ? '12px!important'
                                    : '13px!important'
                            }
                            color={
                                isMobileView() || winWidth <= sizes.smalDevice
                                    ? '#140F4B'
                                    : '#3c3c3c'
                            }
                            opacity={
                                isMobileView() || winWidth <= sizes.smalDevice
                                    ? '70%'
                                    : '100%'
                            }
                            label={t(adjQtyLabel('reportUsage.itemList.other'))}
                            textAlign={'center'}
                            marginBottom={'15px'}
                        />
                    )}
                    <Checkbox 
                        checked={lotItem?.other || false}
                        onCheckboxSelectionChange={(e) =>
                            lotSerialValueEntered(
                                e,
                                item,
                                index,
                                lotItem,
                                lotItemIdx,
                                'otherChecked'
                            )
                        }
                        id="reportUsage-record-reportPayment-QuantityRPCheckboxes-other"
                        margin={'0px 15px 0 0'}
                        labelStyleObj={{
                            fontSize: SEMANTIC_TEXT_SMALL_PX,
                            color: BROWN_FONT_COLOR,
                        }}
                        background={'none'}
                        checkboxBorder={'1.5px solid #555555'}
                        alignItemDirection={'center'}
                        hoverEffect={'false'}
                        disableFocusEffect={'true'}
                        ariaLabel={t('reportUsage.itemList.other')}
                    />
                </Container>
            )}
        </Wrapper>
    );
};

export default QuantityRPCheckboxes;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;

const Container = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${({ padding }) => padding};
    margin-top: ${({ marginTop }) => marginTop};
    margin-left: ${({ marginLeft }) => marginLeft};
`;
